<template>
  <span>

    <v-btn 
      text 
      small
      color="primary"
      
      @click.stop="listDialog= true"
    >
      See more similar Investors
    </v-btn>               
    <v-dialog v-model="listDialog">
        <v-card class="px-7" style="background: #121212;">
          <v-row>
            <v-col cols="12">
              <!-- <p>{{title}}</p> -->
              <v-card-title>
                {{title}}   
                <v-spacer></v-spacer>
                <v-btn color="primary" icon @click="listDialog = false">
                    <v-icon color="white" small>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Investors"
                      single-line
                      hide-details
                    ></v-text-field>
            </v-col>
            <v-col cols="12">
              <!-- <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader> -->
              <v-data-table
                :search="search"
                :headers="headers"
                :items="items"
                :mobile-breakpoint="0"
              >
                <template v-slot:item="row">
                  <tr >
                    <td>
                      <v-btn
                        class="px-2 mr-2"
                        color="primary"
                        min-width="0"
                        icon
                        small
                        :to="'/investors/analyze/' + row.item.id"
                      >
                        <v-icon>
                          mdi-magnify-plus-outline
                        </v-icon>
                      </v-btn>                    
                    </td>                                 
                    <td>{{ row.item.investor }}</td>
                    <td>{{ row.item.classification }}</td>
                    <td>{{ row.item.nb_positions }}</td>
                    <td>{{ (row.item.total_ptf_size/1000000) | numeral('0,0') }}</td>
                    <!-- <td>{{ row.item.management_company }}</td> -->
                    <td>
                      <radial-progress-bar
                        :diameter="50"
                        :completed-steps="10"
                        :total-steps="10"
                        :startColor="row.item.colorStart"
                        :stopColor="row.item.colorEnd"
                        :strokeWidth="5"
                        style="margin: 0 auto;"
                      >
                        {{ row.item.overlap  }}
                      </radial-progress-bar>                            
                      
                      </td>

                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-card-actions>    
            <v-spacer></v-spacer>             
            <v-btn color="primary" text @click="listDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>                
    </v-dialog>
    </span>
</template>

<script>
  import RadialProgressBar from 'vue-radial-progress'
  export default {
    name: 'InvestorAnalyzeComponentSimilarInvestorsExpand',
    props: ['items','title'],
    components: {
      RadialProgressBar,
    },        
    data() {
      return {
        search:"",
        listDialog: false,
        headers: [
          {
            sortable: false,
            text: '',
            align: 'left',
          },          
          {
            text: 'Name',
            align: 'left',
            value: 'investor',
          },
          { text: 'Classification', value: 'classification' },          
          { text: '# Holdings', value: 'nb_positions' },
          { text: 'Ptf Size ($ in millions)', value: 'total_ptf_size' },
          //{ text: 'Mgnt Company', value: 'management_company' },
          { text: 'Similarity', value: 'overlap' },
        ],
        listLoad: true,
        errorbar: false,        
      }
    },
    // mounted () {
    //   this.getListFromApi()
    // },    
    methods: { 
      goToStock(id) {
        this.$router.push({ name: 'StocksAnalyze', params: { stock: id } });
      },           
      // async getListFromApi() {
      //   var self = this
      //   const currentSession = await this.$Amplify.Auth.currentSession()
      //   const currentToken = currentSession.getIdToken().getJwtToken()
      //   this.$http.get(process.env.VUE_APP_API_HOST + '/get-investor-potential-sells/' + self.investor,{
      //     headers: {
      //       'Authorization': currentToken,
      //       'Content-Type': 'application/json'
      //     }
      //   }).then(function (response) {
      //     //console.log(response.data)
      //     self.items = response.data 
      //     self.listLoad = false
      //   }).catch(function (/*error*/) {
      //     //console.log(error)
      //     self.listLoad = false
      //     //self.errorbar = true
      //   })
      // }
    },
  }
</script>